export const multiplayerWaiting = {
  en: {
    loadingResults: 'Loading your results…',
    waitingToFinish: 'Waiting for you to finish…',
    waitingForPlayers: 'Waiting for other players',
    resultsAlmostReady: 'Your results are locked in. We’re syncing everyone else now.',
    allPlayersFinished: 'All Players Finished!',
    youFinished: 'You Finished!',
    gameEndOnTimer: 'Game will end when timer expires',
    waitingForTimer: 'Waiting for game timer to complete...',
    gameTimeRemaining: 'Game Time Remaining',
    allPlayersEndSimultaneously: 'All players\' games will end simultaneously',
    yourResults: '🎉 Your Results',
    correct: 'Correct',
    accuracy: 'Accuracy',
    time: 'Time',
    playerProgress: 'Player Progress',
    playersFinished: '{{finished}} of {{total}} players finished',
    everyoneFinishedEarly: '🎉 Everyone finished early!',
    endGameNow: 'End Game Now',
    waitForAutoEnd: 'Or wait {{time}} for automatic end',
    whileYouWait: 'While you wait...',
    realTimeFairScoring: 'In real-time mode, games end together for fair scoring!',
    othersStillAnswering: 'Other players are still answering questions.',
    gameEndingSoon: 'Game ending soon! Final results will be calculated.',
    reviewAnswers: 'Review my answers',
    goHome: 'Go home',
    resetRoom: 'Reset room',
    resetting: 'Resetting...',
  },
  
  es: {
    waitingForPlayers: 'Esperando a los demás jugadores',
    resultsAlmostReady: 'Tus resultados están guardados. Estamos sincronizando a los demás.',
    reviewAnswers: 'Revisar mis respuestas',
    goHome: 'Ir al inicio',
    resetRoom: 'Reiniciar sala',
    resetting: 'Reiniciando…',
    loadingResults: 'Cargando tus resultados…',
    waitingToFinish: 'Esperando a que termines…',
    allPlayersFinished: '¡Todos los Jugadores Terminaron!',
    youFinished: '¡Terminaste!',
    gameEndOnTimer: 'El juego terminará cuando expire el tiempo',
    waitingForTimer: 'Esperando a que se complete el temporizador del juego...',
    gameTimeRemaining: 'Tiempo Restante del Juego',
    allPlayersEndSimultaneously: 'Los juegos de todos los jugadores terminarán simultáneamente',
    yourResults: '🎉 Tus Resultados',
    correct: 'Correctas',
    accuracy: 'Precisión',
    time: 'Tiempo',
    playerProgress: 'Progreso de Jugadores',
    playersFinished: '{{finished}} de {{total}} jugadores terminaron',
    everyoneFinishedEarly: '¡🎉 Todos terminaron temprano!',
    endGameNow: 'Terminar Juego Ahora',
    waitForAutoEnd: 'O espera {{time}} para terminar automáticamente',
    whileYouWait: 'Mientras esperas...',
    realTimeFairScoring: '¡En modo tiempo real, los juegos terminan juntos para una puntuación justa!',
    othersStillAnswering: 'Otros jugadores aún están respondiendo preguntas.',
    gameEndingSoon: '¡El juego terminará pronto! Se calcularán los resultados finales.',
  },
  
  fr: {
    waitingForPlayers: 'En attente des autres joueurs',
    resultsAlmostReady: 'Vos résultats sont enregistrés. Nous synchronisons les autres joueurs.',
    reviewAnswers: 'Revoir mes réponses',
    goHome: 'Accueil',
    resetRoom: 'Réinitialiser le salon',
    resetting: 'Réinitialisation…',
    loadingResults: 'Chargement de vos résultats…',
    waitingToFinish: 'En attente que vous finissiez…',
    allPlayersFinished: 'Tous les Joueurs ont Terminé !',
    youFinished: 'Vous avez Terminé !',
    gameEndOnTimer: 'Le jeu se terminera à l\'expiration du temps',
    waitingForTimer: 'En attente de la fin du minuteur de jeu...',
    gameTimeRemaining: 'Temps de Jeu Restant',
    allPlayersEndSimultaneously: 'Les jeux de tous les joueurs se termineront simultanément',
    yourResults: '🎉 Vos Résultats',
    correct: 'Correctes',
    accuracy: 'Précision',
    time: 'Temps',
    playerProgress: 'Progrès des Joueurs',
    playersFinished: '{{finished}} sur {{total}} joueurs ont terminé',
    everyoneFinishedEarly: '🎉 Tout le monde a fini tôt !',
    endGameNow: 'Terminer le Jeu Maintenant',
    waitForAutoEnd: 'Ou attendre {{time}} pour la fin automatique',
    whileYouWait: 'Pendant que vous attendez...',
    realTimeFairScoring: 'En mode temps réel, les jeux se terminent ensemble pour un score équitable !',
    othersStillAnswering: 'D\'autres joueurs répondent encore aux questions.',
    gameEndingSoon: 'Le jeu se termine bientôt ! Les résultats finaux seront calculés.',
  },
  
  de: {
    waitingForPlayers: 'Warten auf andere Spieler',
    resultsAlmostReady: 'Deine Ergebnisse sind gespeichert. Wir synchronisieren jetzt alle anderen.',
    reviewAnswers: 'Meine Antworten ansehen',
    goHome: 'Zur Startseite',
    resetRoom: 'Raum zurücksetzen',
    resetting: 'Wird zurückgesetzt…',
    loadingResults: 'Lade Ihre Ergebnisse…',
    waitingToFinish: 'Warte darauf, dass Sie fertig werden…',
    allPlayersFinished: 'Alle Spieler sind Fertig!',
    youFinished: 'Sie sind Fertig!',
    gameEndOnTimer: 'Das Spiel endet, wenn die Zeit abläuft',
    waitingForTimer: 'Warte auf Vervollständigung des Spiel-Timers...',
    gameTimeRemaining: 'Verbleibende Spielzeit',
    allPlayersEndSimultaneously: 'Alle Spieler-Spiele enden gleichzeitig',
    yourResults: '🎉 Ihre Ergebnisse',
    correct: 'Richtig',
    accuracy: 'Genauigkeit',
    time: 'Zeit',
    playerProgress: 'Spieler-Fortschritt',
    playersFinished: '{{finished}} von {{total}} Spielern fertig',
    everyoneFinishedEarly: '🎉 Alle haben früh beendet!',
    endGameNow: 'Spiel Jetzt Beenden',
    waitForAutoEnd: 'Oder {{time}} auf automatisches Ende warten',
    whileYouWait: 'Während Sie warten...',
    realTimeFairScoring: 'Im Echtzeit-Modus enden Spiele zusammen für faire Bewertung!',
    othersStillAnswering: 'Andere Spieler beantworten noch Fragen.',
    gameEndingSoon: 'Spiel endet bald! Endergebnisse werden berechnet.',
  },
  
  pt: {
    waitingForPlayers: 'Aguardando os outros jogadores',
    resultsAlmostReady: 'Seus resultados estão salvos. Estamos sincronizando os outros agora.',
    reviewAnswers: 'Revisar minhas respostas',
    goHome: 'Ir para o início',
    resetRoom: 'Redefinir sala',
    resetting: 'Redefinindo…',
    loadingResults: 'Carregando seus resultados…',
    waitingToFinish: 'Esperando você terminar…',
    allPlayersFinished: 'Todos os Jogadores Terminaram!',
    youFinished: 'Você Terminou!',
    gameEndOnTimer: 'O jogo terminará quando o tempo expirar',
    waitingForTimer: 'Aguardando a conclusão do cronômetro do jogo...',
    gameTimeRemaining: 'Tempo Restante do Jogo',
    allPlayersEndSimultaneously: 'Os jogos de todos os jogadores terminarão simultaneamente',
    yourResults: '🎉 Seus Resultados',
    correct: 'Corretas',
    accuracy: 'Precisão',
    time: 'Tempo',
    playerProgress: 'Progresso dos Jogadores',
    playersFinished: '{{finished}} de {{total}} jogadores terminaram',
    everyoneFinishedEarly: '🎉 Todo mundo terminou cedo!',
    endGameNow: 'Terminar Jogo Agora',
    waitForAutoEnd: 'Ou aguarde {{time}} para o fim automático',
    whileYouWait: 'Enquanto você espera...',
    realTimeFairScoring: 'No modo tempo real, os jogos terminam juntos para pontuação justa!',
    othersStillAnswering: 'Outros jogadores ainda estão respondendo perguntas.',
    gameEndingSoon: 'Jogo terminando em breve! Resultados finais serão calculados.',
  },
  
  // Adding remaining 5 languages: ru, tl, it, am, ko
  ru: {
    waitingForPlayers: 'Ожидание других игроков',
    resultsAlmostReady: 'Ваши результаты сохранены. Сейчас синхронизируем остальных.',
    reviewAnswers: 'Просмотреть мои ответы',
    goHome: 'На главную',
    resetRoom: 'Сбросить комнату',
    resetting: 'Сброс…',
    loadingResults: 'Загрузка ваших результатов…',
    waitingToFinish: 'Ожидание завершения…',
    allPlayersFinished: 'Все игроки закончили!',
    youFinished: 'Вы закончили!',
    gameEndOnTimer: 'Игра закончится когда истечет время',
    waitingForTimer: 'Ожидание завершения таймера игры...',
    gameTimeRemaining: 'Оставшееся время игры',
    allPlayersEndSimultaneously: 'Игры всех игроков закончатся одновременно',
    yourResults: '🎉 Ваши результаты',
    correct: 'Правильно',
    accuracy: 'Точность',
    time: 'Время',
    playerProgress: 'Прогресс игроков',
    playersFinished: '{{finished}} из {{total}} игроков закончили',
    everyoneFinishedEarly: '🎉 Все закончили рано!',
    endGameNow: 'Закончить игру сейчас',
    waitForAutoEnd: 'Или ждать {{time}} для автоматического завершения',
    whileYouWait: 'Пока вы ждете...',
    realTimeFairScoring: 'В режиме реального времени игры заканчиваются вместе для честного подсчета!',
    othersStillAnswering: 'Другие игроки все еще отвечают на вопросы.',
    gameEndingSoon: 'Игра скоро закончится! Финальные результаты будут рассчитаны.',
  },
  
  tl: {
    waitingForPlayers: 'Naghihintay sa ibang manlalaro',
    resultsAlmostReady: 'Naka-lock na ang iyong mga resulta. Sini-sync na namin ang iba.',
    reviewAnswers: 'Suriin ang aking mga sagot',
    goHome: 'Umuwi',
    resetRoom: 'I-reset ang Kuwarto',
    resetting: 'Nire-reset…',
    loadingResults: 'Naglo-load ng inyong mga resulta…',
    waitingToFinish: 'Naghihintay na matapos kayo…',
    allPlayersFinished: 'Lahat ng mga Manlalaro ay Tapos na!',
    youFinished: 'Tapos na Kayo!',
    gameEndOnTimer: 'Ang laro ay magtatapos kapag naubos na ang oras',
    waitingForTimer: 'Naghihintay para matapos ang timer ng laro...',
    gameTimeRemaining: 'Natitirang Oras ng Laro',
    allPlayersEndSimultaneously: 'Ang mga laro ng lahat ng manlalaro ay magtatapos nang sabay-sabay',
    yourResults: '🎉 Inyong mga Resulta',
    correct: 'Tama',
    accuracy: 'Katumpakan',
    time: 'Oras',
    playerProgress: 'Progreso ng Manlalaro',
    playersFinished: '{{finished}} sa {{total}} na manlalaro ay tapos na',
    everyoneFinishedEarly: '🎉 Lahat ay natapos nang maaga!',
    endGameNow: 'Tapusin ang Laro Ngayon',
    waitForAutoEnd: 'O maghintay ng {{time}} para sa automatic na pagtatapos',
    whileYouWait: 'Habang naghihintay kayo...',
    realTimeFairScoring: 'Sa real-time mode, ang mga laro ay nagtatapos nang magkakasama para sa patas na pag-score!',
    othersStillAnswering: 'Ang iba pang mga manlalaro ay sumasagot pa rin ng mga tanong.',
    gameEndingSoon: 'Ang laro ay malapit nang matapos! Ang mga huling resulta ay makakalkula.',
  },
  
  it: {
    waitingForPlayers: 'In attesa degli altri giocatori',
    resultsAlmostReady: 'I tuoi risultati sono salvati. Stiamo sincronizzando gli altri.',
    reviewAnswers: 'Rivedi le mie risposte',
    goHome: 'Vai alla home',
    resetRoom: 'Reimposta stanza',
    resetting: 'Reimpostazione…',
    loadingResults: 'Caricamento dei vostri risultati…',
    waitingToFinish: 'Aspettando che finiate…',
    allPlayersFinished: 'Tutti i Giocatori hanno Finito!',
    youFinished: 'Avete Finito!',
    gameEndOnTimer: 'Il gioco finirà quando scadrà il tempo',
    waitingForTimer: 'Aspettando il completamento del timer di gioco...',
    gameTimeRemaining: 'Tempo di Gioco Rimanente',
    allPlayersEndSimultaneously: 'I giochi di tutti i giocatori finiranno simultaneamente',
    yourResults: '🎉 I Vostri Risultati',
    correct: 'Corrette',
    accuracy: 'Precisione',
    time: 'Tempo',
    playerProgress: 'Progresso Giocatori',
    playersFinished: '{{finished}} di {{total}} giocatori hanno finito',
    everyoneFinishedEarly: '🎉 Tutti hanno finito presto!',
    endGameNow: 'Termina Gioco Ora',
    waitForAutoEnd: 'O aspetta {{time}} per la fine automatica',
    whileYouWait: 'Mentre aspettate...',
    realTimeFairScoring: 'In modalità tempo reale, i giochi finiscono insieme per un punteggio equo!',
    othersStillAnswering: 'Altri giocatori stanno ancora rispondendo alle domande.',
    gameEndingSoon: 'Il gioco sta per finire! I risultati finali saranno calcolati.',
  },
  
  am: {
    waitingForPlayers: 'ሌሎች ተጫዋቾችን በመጠበቅ ላይ',
    resultsAlmostReady: 'ውጤትዎ ተቆልፏል። አሁን ሌሎችን እያመሳሰልን ነው።',
    reviewAnswers: 'መልሶቼን ገምግም',
    goHome: 'ወደ መነሻ ሂድ',
    resetRoom: 'ክፍሉን ዳግም አስጀምር',
    resetting: 'ዳግም በማስጀመር ላይ…',
    loadingResults: 'የእርስዎን ውጤቶች በመጫን ላይ…',
    waitingToFinish: 'እስከ ማጠናቀቅዎ ድረስ በመጠበቅ ላይ…',
    allPlayersFinished: 'ሁሉም ተጫዋቾች አጠናቅቀዋል!',
    youFinished: 'አጠናቅቀዋል!',
    gameEndOnTimer: 'ጊዜው ሲያልቅ ጨዋታው ይጠናቀቃል',
    waitingForTimer: 'የጨዋታው ጊዜ እስከሚያልቅ በመጠበቅ ላይ...',
    gameTimeRemaining: 'የቀረው የጨዋታ ጊዜ',
    allPlayersEndSimultaneously: 'የሁሉም ተጫዋቾች ጨዋታዎች በአንድ ጊዜ ይጠናቀቃሉ',
    yourResults: '🎉 የእርስዎ ውጤቶች',
    correct: 'ትክክል',
    accuracy: 'ትክክለኛነት',
    time: 'ጊዜ',
    playerProgress: 'የተጫዋች እድገት',
    playersFinished: '{{finished}} ከ{{total}} ተጫዋቾች አጠናቅቀዋል',
    everyoneFinishedEarly: '🎉 ሁሉም ቀደም ብለው አጠናቅቀዋል!',
    endGameNow: 'ጨዋታውን አሁን አቁም',
    waitForAutoEnd: 'ወይም {{time}} ለራስ-ሰር ማጠናቀቂያ ይጠብቁ',
    whileYouWait: 'በሚጠብቁበት ጊዜ...',
    realTimeFairScoring: 'በትክክለኛ ጊዜ ሁነታ፣ ጨዋታዎች ለፍትሃዊ ውጤት አንድ ላይ ይጠናቀቃሉ!',
    othersStillAnswering: 'ሌሎች ተጫዋቾች አሁንም ጥያቄዎችን እየመለሱ ናቸው።',
    gameEndingSoon: 'ጨዋታው በቅርቡ ይጠናቀቃል! የመጨረሻ ውጤቶች ይሰላሉ።',
  },
  
  ko: {
    waitingForPlayers: '다른 플레이어를 기다리는 중',
    resultsAlmostReady: '결과가 저장되었습니다. 다른 플레이어와 동기화하는 중입니다.',
    reviewAnswers: '내 답변 보기',
    goHome: '홈으로',
    resetRoom: '방 초기화',
    resetting: '초기화 중…',
    loadingResults: '결과를 불러오는 중…',
    waitingToFinish: '완료될 때까지 기다리는 중…',
    allPlayersFinished: '모든 플레이어가 완료했습니다!',
    youFinished: '완료했습니다!',
    gameEndOnTimer: '시간이 만료되면 게임이 종료됩니다',
    waitingForTimer: '게임 타이머 완료를 기다리는 중...',
    gameTimeRemaining: '남은 게임 시간',
    allPlayersEndSimultaneously: '모든 플레이어의 게임이 동시에 종료됩니다',
    yourResults: '🎉 당신의 결과',
    correct: '정답',
    accuracy: '정확도',
    time: '시간',
    playerProgress: '플레이어 진행률',
    playersFinished: '{{total}}명 중 {{finished}}명이 완료했습니다',
    everyoneFinishedEarly: '🎉 모든 사람이 일찍 완료했습니다!',
    endGameNow: '지금 게임 종료',
    waitForAutoEnd: '또는 {{time}} 자동 종료를 기다리세요',
    whileYouWait: '기다리는 동안...',
    realTimeFairScoring: '실시간 모드에서는 공정한 점수를 위해 게임이 함께 종료됩니다!',
    othersStillAnswering: '다른 플레이어들이 아직 질문에 답하고 있습니다.',
    gameEndingSoon: '게임이 곧 종료됩니다! 최종 결과가 계산됩니다.',
  },
};
